import type { ComponentProps } from "react";
import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { FullscreenAlert, WarningCircleIcon } from "@/shared/ui";

export const PaymentFailedFullscreenAlert = (
  props: ComponentProps<typeof FullscreenAlert.Root>,
) => {
  return (
    <FullscreenAlert.Root {...props}>
      <FullscreenAlert.Content theme="light">
        <FullscreenAlert.Header icon={WarningCircleIcon}>
          <FullscreenAlert.Title>
            {t`The payment was unsuccessful`}
          </FullscreenAlert.Title>
          <FullscreenAlert.Description>
            {t`Your payment could not be verified. Please try again later or use another payment method.`}
          </FullscreenAlert.Description>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Cancel variant="secondary" asChild>
            <Link to={ROUTES.BILLING.OVERVIEW} replace>{t`Close`}</Link>
          </FullscreenAlert.Cancel>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
